module.exports = __webpack_public_path__ + "img/ic_pdf.f2fe8d02.svg";